import { Column } from 'app/design/primitives/box';
import { RemoteError } from 'app/design/primitives/remote-error';
import TextDivider from 'app/design/primitives/text-divider';
import type { useSocialConnect } from 'app/screens/onboarding/signup';
import { createTheme as createDSTheme } from 'app/shopify';
import { FeatureFlag, isFeatureEnabled } from 'app/utils/helpers';
import type { ReactNode, RefObject } from 'react';
import { useTranslation } from 'react-i18next';
import { View, type StyleProp, type ViewStyle } from 'react-native';

const theme = createDSTheme();

interface IntroSSOSectionProps {
  onLayoutSSO: () => void;
  refSSO: RefObject<View | null>;
  renderSSOButtons: (args: { style?: StyleProp<ViewStyle> }) => ReactNode;
  ssoError: ReturnType<typeof useSocialConnect>['ssoError'];
}

export function IntroSSOSection({ onLayoutSSO, refSSO, renderSSOButtons, ssoError }: IntroSSOSectionProps) {
  const { t: tLogin } = useTranslation('login');
  const { t: tAPI } = useTranslation('api-errors');

  if (!isFeatureEnabled(FeatureFlag.sso)) {
    return null;
  }

  return (
    <>
      {renderSSOButtons({ style: { marginVertical: theme.spacing['spacing.general.x1'] } })}
      <Column marginVertical="spacing.general.x1">
        <TextDivider text={tLogin('or', { ns: 'common' })} />
      </Column>
      {ssoError ? (
        <View collapsable={false} ref={refSSO} style={{ width: '100%' }}>
          <Column gap="spacing.general.x4" marginTop="spacing.general.x4" onLayout={onLayoutSSO}>
            <RemoteError {...{ error: ssoError, message: tAPI(ssoError.message) }} />
          </Column>
        </View>
      ) : null}
    </>
  );
}
